export default __webpack_public_path__ + "static/media/arrow-black.bdf42ebf.svg";